// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"44c80276","149":"aee7cb6f","175":"bcadff11","236":"d8001b0d","594":"28aa1814","686":"fc36527b","709":"520fcf31","748":"d31cec22","872":"38fc3657"}[chunkId] + ".chunk.js";
};